export default __webpack_public_path__ + "static/media/css.409b3a09.png";